import {
  GET_NEWS_LOADING,
  GET_NEWS_SUCCESS,
  GET_NEWS_ERROR,
  CREATE_NEWS_LOADING,
  CREATE_NEWS_SUCCESS,
  CREATE_NEWS_ERROR,
  EDIT_NEWS_LOADING,
  EDIT_NEWS_SUCCESS,
  EDIT_NEWS_ERROR,
  DELETE_NEWS_LOADING,
  DELETE_NEWS_SUCCESS,
  DELETE_NEWS_ERROR,
} from "../../../constant/actionTypes";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiDelete, apiGet, apiPut } from "../../../utils/apiRequests";

export const getNews = () => (dispatch) => {
  dispatch({ type: GET_NEWS_LOADING });
  apiGet(
    ApiEndpoints.news.base,
    (response) => {
    //   console.log("get news response ==============> ", response);
      if (response.error == true) {
        dispatch({ type: GET_NEWS_ERROR, response: response.message });
      } else {
        dispatch({ type: GET_NEWS_SUCCESS, response: response });
      }
    },
    (error) => {
    //   console.log("error ===>>>>", error);
      dispatch({ type: GET_NEWS_ERROR, response: error });
    }
  );
};

export const createNews = (data) => (dispatch) => {
  dispatch({ type: CREATE_NEWS_LOADING });
  apiPut(
    `${ApiEndpoints.news.base}${ApiEndpoints.news.add}`,
    data,
    (response) => {
    //   console.log("create news response ....", response);

      if (response.error == true) {
        dispatch({ type: CREATE_NEWS_ERROR, response: response.message });
      } else {
        dispatch({ type: CREATE_NEWS_SUCCESS, response: response });
      }
    },
    (error) => {
    //   console.log("error ===>>>>", error);
      dispatch({ type: CREATE_NEWS_ERROR, response: error });
    }
  );
};

export const deleteNews = (id) => (dispatch) => {
  dispatch({ type: DELETE_NEWS_ERROR });
  apiDelete(
    `${ApiEndpoints.news.base}${ApiEndpoints.news.delete}${id}`,
    (response) => {
    //   console.log("delete news response ....", response);

      if (response.error == true) {
        dispatch({ type: DELETE_NEWS_ERROR, response: response.message });
      } else {
        dispatch({ type: DELETE_NEWS_SUCCESS, response: response });
      }
    },
    (error) => {
    //   console.log("error ===>>>>", error);
      dispatch({ type: DELETE_NEWS_ERROR, response: error });
    }
  );
};

export const editNews = (id, data) => (dispatch) => {
  dispatch({ type: EDIT_NEWS_LOADING });
  apiPut(
    `${ApiEndpoints.news.base}${ApiEndpoints.news.update}${id}`,
    data,
    (response) => {
    //   console.log("edit news response ....", response);

      if (response.error == true) {
        dispatch({ type: EDIT_NEWS_ERROR, response: response.message });
      } else {
        dispatch({ type: EDIT_NEWS_SUCCESS, response: response });
      }
    },
    (error) => {
    //   console.log("error ===>>>>", error);
      dispatch({ type: EDIT_NEWS_ERROR, response: error });
    }
  );
};
